import { render, staticRenderFns } from "./SpeechToText.vue?vue&type=template&id=13cf87e1&"
import script from "./SpeechToText.vue?vue&type=script&lang=js&"
export * from "./SpeechToText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports